import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref, watch } from 'vue';
import { CountUp, CountUpOptions } from 'countup.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedNumber',
  props: {
    number: { default: 0 },
    duration: { default: 3000 }
  },
  setup(__props: any) {

const props = __props as { number: number, duration: number }



const initialNumber = ref(0);
const counter = ref<HTMLElement>(null);
const countUp = ref<CountUp>(null);

const options = computed<CountUpOptions>(() => {
    return {
        duration: props.duration / 1000,
        startVal: props.number,
        useEasing: true, // true, but no fn specified, means defaults to `easeOutExpo`
        separator: ''
    };
});

onMounted(() => {
    initialNumber.value = props.number;
    // eslint-disable-next-line no-new
    countUp.value = new CountUp(counter.value, props.number, options.value);
    countUp.value.start();
});

watch(
    () => props.number,
    () => {
        countUp.value.update(props.number);
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "counter",
    ref: counter
  }, null, 512))
}
}

})